import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const TransfersIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.7 2.3a1 1 0 1 0-1.4 1.4L18.58 6H9a1 1 0 0 0 0 2h9.59l-2.3 2.3a1 1 0 0 0 1.42 1.4l4-4a1 1 0 0 0 0-1.4l-4-4Zm-10 10a1 1 0 0 1 0 1.4L5.42 16H15a1 1 0 1 1 0 2H5.41l2.3 2.3a1 1 0 1 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.42 0Z" />
    </Icon>
  )
);
export default TransfersIcon;
